$(document).on('click', '[data-call]', function (event) {
  event.preventDefault()

  const fn = window[this.dataset.call]
  if (typeof fn === 'function') {
    fn(...JSON.parse(this.dataset.args || '[]'))
  }
})

$(document).on('click', '[data-submit-form]', function (event) {
  event.preventDefault()
  document.querySelector(this.dataset.submitForm)?.submit()
})

$(document).on('click', '[data-href]', function (event) {
  event.preventDefault()
  window.location = this.dataset.href
})

$(document).on('change', '[data-submit-on-change]', function () {
  this.form?.submit()
})

$(document).on('change', '[data-navigate-on-change]', function () {
  window.location = this.dataset.navigateOnChange
})

$(document).on('input', 'input[type="number"][maxlength]', function () {
  if (this.value.length > this.maxLength) {
    this.value = this.value.slice(0, this.maxLength)
  }
})

$(document).on('select2:open', function () {
  window.setTimeout(function () {
    document.querySelector('.select2-container--open .select2-search__field')?.focus()
  }, 0)
})

$(function () {
  const flash = document.getElementById('flash-messages')
  if (flash && typeof window.showCustomToast === 'function') {
    if (flash.dataset.success) {
      window.showCustomToast(flash.dataset.success, 'success')
    }
    if (flash.dataset.error) {
      Swal.fire({ title: 'Atención', text: flash.dataset.error, icon: 'warning', confirmButtonText: 'Entendido' })
    }
  }

  const passwordModal = document.querySelector('#changePasswordModal[data-force-open]')
  if (passwordModal) {
    passwordModal.addEventListener('hide.bs.modal', event => event.preventDefault())
    new bootstrap.Modal(passwordModal).show()
  }
})

$(document).ajaxError(function (event, xhr) {
  if (xhr.status === 403) {
    Swal.fire('Sin permiso', xhr.responseJSON?.message || 'No tiene permiso para realizar esta acción.', 'warning')
  }
})

$(document).on('show.bs.modal', '[data-load-url]', function () {
  const body = this.querySelector('.modal-body')
  axios
    .get(this.dataset.loadUrl)
    .then(({ data }) => {
      body.innerHTML = data
      window.feather?.replace()
    })
    .catch(() => {
      body.innerHTML = '<p class="text-danger text-center my-3">No se pudo cargar la información.</p>'
    })
})
